// AutoGenerated
export enum EnmCrud {
    "Create" = 1,
    "Update" = 2,
    "Delete" = 3,
}